module.exports = __webpack_public_path__ + "img/emoji-sunglasses240x240.c921be3a.png";